export { MessageInstanceEventClient } from '@atlassian/post-office-context/message-lifecycle';
export type {
	FrontendMessageInstanceEventWithoutRecipient,
	InAppClickedEvent,
	InAppDeliverySuccessfulEvent,
	InAppViewedEvent,
} from '@atlassian/post-office-context/message-lifecycle';
